import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { api } from '../../../context/AuthContext';
import { toast } from 'sonner';

export const RollenMatrix = ({ katalog, onSaved }) => {
  const [m, setM] = useState(katalog.matrix);
  const [busy, setBusy] = useState(false);
  const rollen = katalog.rollen;
  const toggle = (rolle, recht) => {
    const an = m[rolle].includes(recht);
    setM({ ...m, [rolle]: an ? m[rolle].filter((x) => x !== recht) : [...m[rolle], recht] });
  };
  const speichern = async () => {
    setBusy(true);
    try { await api.put('/kanzlei/rechte/matrix', { matrix: m }); toast.success('Rollen gespeichert'); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-x-auto" data-testid="rechte-matrix">
      <table className="w-full text-[13px] min-w-[620px]">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-gray-500 border-b border-gray-100">
          <th className="p-3 font-medium">Recht</th>{rollen.map((r) => <th key={r.key} className="p-3 font-medium text-center">{r.label}</th>)}
        </tr></thead>
        <tbody>
          {katalog.rechte.map((r) => (
            <tr key={r.key} className="border-b border-gray-50 hover:bg-[#f9fbfc]">
              <td className="p-3 text-[#1B3A5C]">{r.label}</td>
              {rollen.map((ro) => (
                <td key={ro.key} className="p-3 text-center">
                  {ro.key === 'admin' ? <Check className="w-4 h-4 text-emerald-600 mx-auto" aria-label="immer" />
                    : <input type="checkbox" checked={m[ro.key].includes(r.key)} disabled={!katalog.darf_verwalten} onChange={() => toggle(ro.key, r.key)} className="w-4 h-4 accent-[#1B3A5C]" data-testid={`matrix-${ro.key}-${r.key}`} />}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="p-4 flex items-center gap-3 border-t border-gray-100">
        <p className="text-xs text-gray-500 flex-1">Admin hat immer alle Rechte. Das Backend prüft jedes Recht serverseitig.</p>
        {katalog.darf_verwalten && <button type="button" disabled={busy} onClick={speichern} className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] hover:bg-[#15304d] text-white text-[13px] disabled:opacity-60" data-testid="matrix-speichern">Speichern</button>}
      </div>
    </div>
  );
};
